import { apiGet } from '@/features/shared/utils/dataFetching'
import {
  type RewardsProgramSavingsQueryKey,
  type RewardsProgramsQueryKey,
} from '@/features/account/services/RewardsPrograms/queries'
import {
  type LoyaltySavingsResponse,
  type ProgramsResponse,
} from '@/features/account/services/RewardsPrograms/types'
import { type QueryFunctionContext } from '@tanstack/react-query'

export const LEGACY_REWARDS_PROGRAMS_URL = 'api/v1/loyalty_programs.json'
export const BFF_REWARDS_PROGRAMS_URL = '/member-web-bff/v1/loyalty/programs'
export const BFF_REWARDS_SAVINGS_URL = '/member-web-bff/v1/loyalty/savings'

export const fetchRewardsProgram = (context: QueryFunctionContext<RewardsProgramsQueryKey>) => {
  const [, { isBFFLoyalty }] = context.queryKey
  return apiGet<ProgramsResponse>({
    config: {
      url: isBFFLoyalty ? BFF_REWARDS_PROGRAMS_URL : LEGACY_REWARDS_PROGRAMS_URL,
    },
    context,
    options: { ignoredMessages: ['no loyalty programs found for customer'] },
    fetcherName: 'fetchRewardsProgram',
  })
}

export const fetchRewardsSavings = (
  context: QueryFunctionContext<RewardsProgramSavingsQueryKey>,
) => {
  const [, { userId, storeId, isBFFLoyalty }] = context.queryKey
  return apiGet<LoyaltySavingsResponse>({
    config: isBFFLoyalty
      ? { url: BFF_REWARDS_SAVINGS_URL, params: { store_id: storeId } }
      : { url: `v2/customer/${userId}/loyalty/${storeId}/savings` },
    context,
    fetcherName: 'fetchRewardsSavings',
  })
}
